import React, {useState} from 'react';
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import PopupSelect from "./PopupSelect";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

/**
 * myPage以外でPopupSelectコンポーネントを
 * 利用したいときに使用する
 */
const PopupSelectAdapter = props => {

  const [inputValue, setInputValue] = useState(props.selectedNames || "");

  const onChangeInputValue = event => {
    setInputValue(e.target.value);
  };

  const onClosePopup = selectedTypes => {
    setInputValue(selectedTypes.map(type => type.name).join("/"));
    props.onClosePopup(selectedTypes);
  };

  const onClickPopupLink = event => {
    props.fetchedData.then(data => {
      ReactDOM.render(
        <PopupSelect
          popupOptions={props.popupOptions}
          recruitmentPrTypes={props.recruitmentPrTypes}
          sectionTypes={data.sectionTypes}
          itemTypes={data.itemTypes}
          isLimitedItem={data.isLimitedItem}
          selectedIds={data.selectedIds.map(Number)}
          onClosePopup={onClosePopup}
          onSubmit={props.onSubmit}
          ButtonArea={props.ButtonArea}
          needSelectedAllButton={props.needSelectedAllButton}
          rootNode={props.rootNode}
        />, props.rootNode
      );
    }).catch(error => {
      console.error(error.message);
      alert(error.message);
    });
  };

  return <props.LinkForPopup onClickPopupLink={onClickPopupLink} onChangeInputValue={onChangeInputValue} inputValue={inputValue} />;
};

PopupSelectAdapter.propTypes = {
  // for PopupSelect
  popupOptions: PropTypes.object,
  needSelectedAllButton: PropTypes.bool,
  rootNode: PropTypes.object,
  fetchedData: PropTypes.object.isRequired,
  recruitmentPrTypes: PropTypes.bool,

  // ポップアップを表示させるための要素
  LinkForPopup: PropTypes.func.isRequired,
  // for self
  onClosePopup: PropTypes.func,
  onSubmit: PropTypes.func,
  ButtonArea: PropTypes.func.isRequired,
  selectedNames: PropTypes.string
};

export default PopupSelectAdapter;
